import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import useAnalytics from "hooks/useAnalytics";

import { AzureIntegrationView } from "../../../useSearchCloudIntegrations/gql";
import CloudIntegrationsAzureActionsDropdown from "../../ActionsDropdown";

const REFETCH_QUERIES = ["SearchAzureIntegrations"];

const IntegrationsAzureTableDropdownActionsCell = ({
  item,
  ...cellProps
}: TableSimpleCellProps<AzureIntegrationView>) => {
  const trackAnalytics = useAnalytics();

  return (
    <TableSimpleCell {...cellProps}>
      <CloudIntegrationsAzureActionsDropdown
        integration={item}
        trackAnalytics={trackAnalytics}
        refetchQueriesOnEdit={REFETCH_QUERIES}
        refetchQueriesOnDelete={REFETCH_QUERIES}
      />
    </TableSimpleCell>
  );
};

export default IntegrationsAzureTableDropdownActionsCell;
